import type { Checkout } from '@vp/common';

/**
 * Whether a blueprint is something a seat can be sold as.
 *
 * Add-ons are excluded because seats.io renders one entry per pricing ticketType, so an
 * add-on attached to a seating category becomes a pickable "ticket type" for every seat in
 * it, and choosing it carts the add-on through the seat-ticket path. They stay purchasable
 * from the Add-Ons list below the map, which reads the blueprints separately.
 *
 * Excluding add-ons rather than allowing only `'ticket'` is deliberate: the wire type is a
 * nullable string and the API layer casts it into a required union, so a blueprint whose
 * ticketType is absent or unrecognised is a state the domain type denies but the API can
 * send. Such a blueprint must keep its seat priced — dropping a real ticket type would
 * strip its category from the pricing model and make buyable seats unbuyable.
 *
 * Shared so the chart's pricing, the tier list the buyer reads and the page's `view_item`
 * payload cannot drift: a seated page renders one row per seat-selectable blueprint and
 * reports the same set, so all three name exactly the tiers the chart prices.
 */
export const isSeatSelectable = (
  { ticketType }: Checkout.TicketBlueprint.CheckoutTicketBlueprint,
): boolean => ticketType != 'addon';
